import { NewsletterRecipientsRow as SharedNewsletterRecipientsRow } from '@/features/dryad';
import { ConditionType } from './condition-types';
import { ConditionTypeSelect } from './condition-type-select';

type NewsletterRecipientsRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/** The people surface's binding of the shared newsletter-recipients row. */
export function NewsletterRecipientsRow({ id }: NewsletterRecipientsRowProps) {
  return (
    <SharedNewsletterRecipientsRow
      id={id}
      conditionType={ConditionType.NewsletterRecipients}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.NewsletterRecipients} />}
    />
  );
}
